/** @format */

import "./index.css";

export function Header() {
  return (
    <>
      <header>
        <div className="header">
          <span>Devesh Vishnoi</span>
          <a href="https://github.com/DeveshVishnoi">
            <span>GitHub</span>
          </a>
          <a href="https://www.linkedin.com/in/devesh-vishnoi-90aa571b8/">
            <span>LinkedIn</span>
          </a>
        </div>
      </header>
    </>
  );
}
